// axiosInstance.js
import axios from 'axios';
import { signOutStart, sessionExpired, signOutFailure} from '../redux/user/userActions';
import {store} from '../redux/store'
import baseUrl from "../config/api";
const axiosInstance = axios.create({
  baseURL: baseUrl, 
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const { status } = error.response;
    if (status === 401) {
      store.dispatch(signOutStart());
      try {
        localStorage.removeItem("userToken");
        store.dispatch(sessionExpired())
        store.dispatch({ type: "CLOSE_DROPDOWN" });
      } catch (error) {
        store.dispatch(signOutFailure());
      } 
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
